import { IViewModel } from '../interfaces/view-model.interface';

export class TestConfiguration implements IViewModel {
    public id: number = 0; // Note:  this value is not used.

    public jsonConfig: string;
}
